export default "__VITE_ASSET__f37e1b37__"